import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

let promise: Promise<Types.ICasinoConfiguration> | undefined;

export const useGetPaymentsConfiguration = () => {
    const send = useGenericSend();
    const casinoname = useAppSelector(prop('casinoName'));

    return useCallback(async (): Promise<Types.ICasinoConfiguration> => {
        if (promise) {
            return promise;
        }

        promise = new Promise((resolve, reject) => {
            send<object, Types.IGetPaymentsConfigurationResponseData>({
                ID: 33032,
                responses: [33030, 33031],
                description: 'Get payments configuration',
                casinoname
            })
            .then(({ data }) => {
                // for backbone compatibility
                dispatcher.dispatch('user:getPaymentsConfiguration:success', { data });

                resolve(data?.casinoConfiguration?.casino);
            })
            .catch((error) => reject(error));
        });

        return promise;
    }, [casinoname, send]);
};
